var _rect, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 25,
    fill: "#003B6E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_261_20487",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 70,
    height: 70
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8692 37.5602C46.0302 36.7211 44.6699 36.7211 43.8309 37.5602C42.9918 38.3992 42.9918 39.7595 43.8309 40.5985L48.0948 44.8624H30.7763C29.5897 44.8624 28.6279 45.8243 28.6279 47.0109C28.6279 48.1974 29.5897 49.1593 30.7763 49.1593H48.0948L43.8309 53.4232C42.9918 54.2622 42.9918 55.6225 43.8309 56.4616C44.6699 57.3006 46.0302 57.3006 46.8692 56.4616L54.8007 48.53C55.6398 47.691 55.6398 46.3307 54.8007 45.4917L46.8692 37.5602Z",
    fill: "#68778D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6255 61.6512C18.6255 66.4671 22.5128 70.3709 27.318 70.4139C28.4908 73.8897 31.7777 76.3923 35.6491 76.3923C39.5204 76.3923 42.8072 73.8898 43.9802 70.4143H50.0351C52.6072 70.4143 55.0325 69.7843 57.1642 68.6701C57.6914 73.0211 61.3973 76.3923 65.8906 76.3923C69.7621 76.3923 73.049 73.8895 74.2218 70.4137C78.2188 70.3635 81.3736 67.0547 81.3736 63.0686V54.632C81.3736 45.3827 74.3951 37.728 65.4324 36.9559V30.1657C65.4324 26.5407 62.4903 23.6074 58.8677 23.6074H27.3983C22.5562 23.6074 18.6255 27.5278 18.6255 32.3706V61.6512ZM27.3983 27.9043C24.9234 27.9043 22.9224 29.9069 22.9224 32.3706L22.9224 61.6512C22.9224 63.9766 24.7051 65.8912 26.9865 66.0988C27.6995 61.9598 31.3066 58.811 35.6491 58.811C39.9982 58.811 43.6096 61.9693 44.315 66.1174H50.0351C56.1687 66.1174 61.1355 61.1533 61.1355 55.0365V30.1657C61.1355 28.9197 60.1231 27.9043 58.8677 27.9043L27.3983 27.9043ZM65.8906 58.811C65.5737 58.811 65.2608 58.8278 64.9526 58.8605C65.2658 57.638 65.4324 56.3567 65.4324 55.0365V41.275C71.9544 42.0326 77.0768 47.6896 77.0768 54.632V63.0686C77.0768 64.6377 75.9507 65.8762 74.551 66.086C73.8328 61.9534 70.2287 58.811 65.8906 58.811ZM35.6491 63.1079C38.1309 63.1079 40.1429 65.1198 40.1429 67.6017C40.1429 70.0835 38.1309 72.0954 35.6491 72.0954C33.1673 72.0954 31.1554 70.0835 31.1554 67.6017C31.1554 65.1198 33.1673 63.1079 35.6491 63.1079ZM65.8906 63.1079C68.3724 63.1079 70.3843 65.1198 70.3843 67.6017C70.3843 70.0835 68.3724 72.0954 65.8906 72.0954C63.4088 72.0954 61.3968 70.0835 61.3968 67.6017C61.3968 65.1198 63.4088 63.1079 65.8906 63.1079Z",
    fill: "#68778D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_261_20487)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#EAF5FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppicon);
export default __webpack_public_path__ + "static/media/app.icon.6837a90ccf013775e2e6372d84319a7d.svg";
export { ForwardRef as ReactComponent };